module.exports = __webpack_public_path__ + "static/demolition-cost-6b66021542cc361b92805dc2db821fb7.png";